export default __webpack_public_path__ + "static/media/navegacao2_recorte.a3138920.webp";